import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const GoldServices: React.FC = () => {
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [quoteFormData, setQuoteFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    service: '',
    message: ''
  });
  const [contactFormData, setContactFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [isQuoteSubmitting, setIsQuoteSubmitting] = useState(false);
  const [isContactSubmitting, setIsContactSubmitting] = useState(false);
  const [quoteSubmitStatus, setQuoteSubmitStatus] = useState('');
  const [contactSubmitStatus, setContactSubmitStatus] = useState('');

  const handleQuoteSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsQuoteSubmitting(true);
    
    try {
      const formData = new URLSearchParams();
      Object.entries(quoteFormData).forEach(([key, value]) => {
        formData.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d2rkv6gn3xjqzkb8gv5g', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData,
      });

      if (response.ok) {
        setQuoteSubmitStatus('Quote request sent successfully! We will contact you soon.');
        setQuoteFormData({ name: '', email: '', phone: '', company: '', service: '', message: '' });
        setTimeout(() => {
          setIsQuoteModalOpen(false);
          setQuoteSubmitStatus('');
        }, 2000);
      } else {
        setQuoteSubmitStatus('An error occurred while sending the request. Please try again.');
      }
    } catch (error) {
      setQuoteSubmitStatus('An error occurred while sending the request. Please try again.');
    } finally {
      setIsQuoteSubmitting(false);
    }
  };

  const handleContactSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsContactSubmitting(true);
    
    try {
      const formData = new URLSearchParams();
      Object.entries(contactFormData).forEach(([key, value]) => {
        formData.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d2rkv6gn3xjqzkb8gv60', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData,
      });

      if (response.ok) {
        setContactSubmitStatus('Message sent successfully! We will contact you soon.');
        setContactFormData({ name: '', email: '', phone: '', message: '' });
        setTimeout(() => {
          setIsContactModalOpen(false);
          setContactSubmitStatus('');
        }, 2000);
      } else {
        setContactSubmitStatus('An error occurred while sending the message. Please try again.');
      }
    } catch (error) {
      setContactSubmitStatus('An error occurred while sending the message. Please try again.');
    } finally {
      setIsContactSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-[1300] overflow-visible h-[72px]">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between h-[72px]">
            <Link to="/" className="flex items-center" data-discover="true">
              <img 
                alt="Vipa Trading Company" 
                className="h-20 w-auto" 
                src="https://static.readdy.ai/image/b722d8dcf1c144135667d61789b02d4e/99b5c3dffef714fa12a155204a44cba1.png"
              />
            </Link>
            <nav className="hidden lg:flex items-center space-x-8">
              <Link to="/" className="text-[#595A5C] hover:text-[#E71B25] transition-colors font-medium">
                Home
              </Link>
              <div className="relative group">
                <button className="text-[#595A5C] hover:text-[#E71B25] transition-colors font-medium flex items-center cursor-pointer whitespace-nowrap focus:outline-none focus:text-[#E71B25]">
                  Services
                  <i className="ri-arrow-down-s-line ml-1 transition-transform duration-200"></i>
                </button>
                <div className="absolute top-full left-0 mt-0 min-w-[260px] bg-white rounded-lg shadow-lg border border-[#C3AAAB33] z-[1000] transition-all duration-200 opacity-0 invisible group-hover:opacity-100 group-hover:visible -translate-y-2 group-hover:translate-y-0">
                  <div className="absolute top-[-10px] left-0 right-0 h-[10px]"></div>
                  <div className="py-2">
                    <Link to="/services/construction" className="block px-4 py-3 text-[#595A5C] hover:bg-[#F7F7F7] hover:text-[#E71B25] transition-colors text-left">
                      Construction & Roads
                    </Link>
                    <Link to="/services/oil" className="block px-4 py-3 text-[#595A5C] hover:bg-[#F7F7F7] hover:text-[#E71B25] transition-colors text-left">
                      Oil & Gas
                    </Link>
                    <Link to="/services/gold" className="block px-4 py-3 text-[#595A5C] hover:bg-[#F7F7F7] hover:text-[#E71B25] transition-colors text-left">
                      Gold Trading
                    </Link>
                    <Link to="/consultation" className="block px-4 py-3 text-[#595A5C] hover:bg-[#F7F7F7] hover:text-[#E71B25] transition-colors text-left">
                        Consulting
                      </Link>
                  </div>
                </div>
              </div>
              <Link to="/about" className="text-[#595A5C] hover:text-[#E71B25] transition-colors font-medium">
                About Us
              </Link>
              <Link to="/contact" className="text-[#595A5C] hover:text-[#E71B25] transition-colors font-medium">
                Contact Us
              </Link>
            </nav>
            <div className="hidden lg:flex items-center space-x-4">
              <a data-lang="ar" className="text-[#595A5C] hover:text-[#E71B25] transition-colors font-medium cursor-pointer">
                العربية
              </a>
              <button 
                type="button" 
                className="inline-flex items-center justify-center font-medium rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap border-2 border-[#E71B25] text-[#E71B25] hover:bg-[#E71B25] hover:text-white px-4 py-2 text-sm"
                onClick={() => window.open('#contact-form', '_self')}
              >
                Contact Us
              </button>
            </div>
            <button className="lg:hidden text-[#595A5C] cursor-pointer" aria-label="Menu">
              <i className="ri-menu-line text-2xl"></i>
            </button>
          </div>
        </div>
      </header>

      {/* Breadcrumbs */}
      <div className="bg-gray-50 py-4">
        <div className="container mx-auto px-4">
          <nav className="flex items-center text-sm text-gray-600">
            <Link to="/" className="hover:text-[#E71B25] transition-colors">Home</Link>
            <i className="ri-arrow-right-s-line mx-2"></i>
            <Link to="/services" className="hover:text-[#E71B25] transition-colors">Services</Link>
            <i className="ri-arrow-right-s-line mx-2"></i>
            <span className="text-[#595A5C] font-medium">Gold Trading</span>
          </nav>
        </div>
      </div>

      {/* Main Content */}
      <main className="py-20">
        <div className="container mx-auto px-4">
          {/* Hero Section */}
          <div className="text-center mb-16">
            <h1 className="text-5xl font-bold text-[#595A5C] mb-6">Gold & Precious Metals Trading</h1>
            <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
              We specialize in gold and precious metals trading with the highest Swiss quality standards, with full commitment to anti-money laundering laws and transparency.
            </p>
          </div>

          {/* Services Section */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 mb-20">
            <div className="order-2 lg:order-1">
              <img 
                alt="Gold & Precious Metals Trading" 
                className="w-full h-96 object-cover rounded-2xl shadow-lg" 
                src="https://public.readdy.ai/ai/img_res/d6256541c20495d7f38f5fa9f67316ab.jpg"
              />
            </div>
            <div className="order-1 lg:order-2">
              <h2 className="text-3xl font-bold text-[#595A5C] mb-8">Our Service Scope</h2>
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="w-6 h-6 bg-[#E71B25] rounded-full flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#595A5C] mb-2">Gold Bullion Trading</h3>
                    <p className="text-gray-600">Trading high-purity gold bullion with internationally certified standards</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-6 h-6 bg-[#E71B25] rounded-full flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#595A5C] mb-2">Dore Gold & Refining Services</h3>
                    <p className="text-gray-600">Dore gold trading and testing and refining services with Swiss standards</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-6 h-6 bg-[#E71B25] rounded-full flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#595A5C] mb-2">Supply Chain Transparency</h3>
                    <p className="text-gray-600">Ensuring complete transparency in supply chain and tracking mineral sources</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-6 h-6 bg-[#E71B25] rounded-full flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#595A5C] mb-2">Metal Testing & Evaluation</h3>
                    <p className="text-gray-600">Comprehensive testing and evaluation services for precious metals using latest technology</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-6 h-6 bg-[#E71B25] rounded-full flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#595A5C] mb-2">Investment Consulting</h3>
                    <p className="text-gray-600">Specialized consulting for precious metals investment</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Compliance Standards */}
          <div className="bg-gray-50 rounded-2xl p-12 mb-20">
            <h2 className="text-3xl font-bold text-[#595A5C] mb-8 text-center">Compliance & Transparency Standards</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="w-16 h-16 bg-[#E71B25] rounded-xl flex items-center justify-center mx-auto mb-4">
                  <i className="ri-shield-check-line text-white text-2xl"></i>
                </div>
                <h3 className="font-semibold text-[#595A5C] mb-2">KYC/AML Standards</h3>
                <p className="text-gray-600">Full compliance with anti-money laundering and know your customer laws</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-[#E71B25] rounded-xl flex items-center justify-center mx-auto mb-4">
                  <i className="ri-medal-line text-white text-2xl"></i>
                </div>
                <h3 className="font-semibold text-[#595A5C] mb-2">Swiss Standards</h3>
                <p className="text-gray-600">Metal testing and refining according to the highest Swiss quality standards</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-[#E71B25] rounded-xl flex items-center justify-center mx-auto mb-4">
                  <i className="ri-file-shield-line text-white text-2xl"></i>
                </div>
                <h3 className="font-semibold text-[#595A5C] mb-2">Certified Documentation</h3>
                <p className="text-gray-600">All our transactions are backed by internationally certified documentation</p>
              </div>
            </div>
          </div>

          {/* Why Choose Us */}
          <div className="mb-20">
            <h2 className="text-3xl font-bold text-[#595A5C] mb-12 text-center">Why Choose Vipa for Trading?</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center bg-white p-8 rounded-2xl shadow-lg">
                <div className="w-20 h-20 bg-[#E71B25] rounded-2xl flex items-center justify-center mx-auto mb-6">
                  <i className="ri-vip-crown-line text-white text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-[#595A5C] mb-4">Exceptional Quality</h3>
                <p className="text-gray-600">We deal only with high-quality precious metals with guaranteed purity</p>
              </div>
              <div className="text-center bg-white p-8 rounded-2xl shadow-lg">
                <div className="w-20 h-20 bg-[#E71B25] rounded-2xl flex items-center justify-center mx-auto mb-6">
                  <i className="ri-shield-user-line text-white text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-[#595A5C] mb-4">Security & Trust</h3>
                <p className="text-gray-600">Full commitment to the highest security and transparency standards in all transactions</p>
              </div>
              <div className="text-center bg-white p-8 rounded-2xl shadow-lg">
                <div className="w-20 h-20 bg-[#E71B25] rounded-2xl flex items-center justify-center mx-auto mb-6">
                  <i className="ri-exchange-line text-white text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-[#595A5C] mb-4">Flexible Dealing</h3>
                <p className="text-gray-600">Flexible and customized solutions that suit diverse client needs</p>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <section className="py-20 bg-red-600">
            <div className="container mx-auto px-4 text-center">
              <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6">
                Need a Specialized Consultation?
              </h2>
              <p className="text-xl text-red-100 mb-10 max-w-3xl mx-auto">
                Contact us today to get a customized consultation and quote that matches your requirements and business objectives.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Link to="/contact">
                  <button 
                    type="button" 
                    className="inline-flex items-center justify-center font-medium rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap bg-white text-[#E71B25] hover:bg-gray-100 shadow-sm hover:shadow-md px-8 py-4 text-lg"
                  >
                    Contact Us
                  </button>
                </Link>
                <a 
                  href="mailto:info@vipatradingco.com"
                  className="inline-flex items-center justify-center font-medium rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap bg-transparent border-2 border-white text-white hover:bg-white hover:text-[#E71B25] px-8 py-4 text-lg"
                >
                  Email Us
                </a>
              </div>
            </div>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-[#2B2C2E] text-white">
        <div className="container mx-auto px-4 py-16">
          <div className="hidden md:grid md:grid-cols-4 gap-12">
            <div className="space-y-6 md:col-span-2">
              <div>
                <div className="flex items-center mb-6">
                  <div className="w-16 h-16 flex items-center justify-center mr-4">
                    <img 
                      alt="Vipa Trading Company" 
                      className="h-16 w-auto" 
                      src="https://static.readdy.ai/image/b722d8dcf1c144135667d61789b02d4e/99b5c3dffef714fa12a155204a44cba1.png"
                    />
                  </div>
                  <div>
                    <h2 className="text-2xl font-bold text-white mb-1">Vipa Trading Company</h2>
                    <p className="text-[#E71B25] text-sm font-medium">VIPA Trading Company</p>
                  </div>
                </div>
                <p className="text-gray-300 text-base leading-relaxed mb-6">
                  A leading Kuwaiti multi-activity company, providing integrated solutions in construction & roads, petroleum, gold, defense, and consulting with the highest international quality standards.
                </p>
                <div className="space-y-3">
                  <a 
                    href="mailto:info@vipatradingco.com" 
                    className="text-gray-300 hover:text-[#E71B25] transition-colors text-base inline-flex items-center cursor-pointer group"
                  >
                    <div className="w-8 h-8 bg-gray-700 rounded-lg flex items-center justify-center mr-3 group-hover:bg-[#E71B25] transition-colors">
                      <i className="ri-mail-line text-sm"></i>
                    </div>
                    info@vipatradingco.com
                  </a>
                  <div className="text-gray-300 text-base inline-flex items-center">
                    <div className="w-8 h-8 bg-gray-700 rounded-lg flex items-center justify-center mr-3">
                      <i className="ri-map-pin-line text-sm"></i>
                    </div>
                    Kuwait
                  </div>
                </div>
              </div>
            </div>
            <div>
              <h3 className="text-white font-bold text-xl mb-8 relative">
                Quick Links
                <div className="absolute bottom-0 left-0 w-12 h-0.5 bg-[#E71B25]"></div>
              </h3>
              <ul className="space-y-4">
                <li>
                  <Link 
                    to="/" 
                    className="text-gray-300 hover:text-[#E71B25] transition-colors text-base py-2 cursor-pointer block group"
                  >
                    <i className="ri-arrow-right-s-line mr-2 group-hover:translate-x-1 transition-transform"></i>
                    Home
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/services" 
                    className="text-gray-300 hover:text-[#E71B25] transition-colors text-base py-2 cursor-pointer block group"
                  >
                    <i className="ri-arrow-right-s-line mr-2 group-hover:translate-x-1 transition-transform"></i>
                    Services
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/about" 
                    className="text-gray-300 hover:text-[#E71B25] transition-colors text-base py-2 cursor-pointer block group"
                  >
                    <i className="ri-arrow-right-s-line mr-2 group-hover:translate-x-1 transition-transform"></i>
                    About Us
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/contact" 
                    className="text-gray-300 hover:text-[#E71B25] transition-colors text-base py-2 cursor-pointer block group"
                  >
                    <i className="ri-arrow-right-s-line mr-2 group-hover:translate-x-1 transition-transform"></i>
                    Contact Us
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="text-white font-bold text-xl mb-8 relative">
                Our Services
                <div className="absolute bottom-0 left-0 w-12 h-0.5 bg-[#E71B25]"></div>
              </h3>
              <ul className="space-y-4">
                <li>
                  <Link 
                    to="/services/construction" 
                    className="text-gray-300 hover:text-[#E71B25] transition-colors text-base py-2 cursor-pointer block group"
                  >
                    <i className="ri-arrow-right-s-line mr-2 group-hover:translate-x-1 transition-transform"></i>
                    Construction & Roads
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/services/oil" 
                    className="text-gray-300 hover:text-[#E71B25] transition-colors text-base py-2 cursor-pointer block group"
                  >
                    <i className="ri-arrow-right-s-line mr-2 group-hover:translate-x-1 transition-transform"></i>
                    Oil & Gas
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/services/gold" 
                    className="text-gray-300 hover:text-[#E71B25] transition-colors text-base py-2 cursor-pointer block group"
                  >
                    <i className="ri-arrow-right-s-line mr-2 group-hover:translate-x-1 transition-transform"></i>
                    Gold Trading
                  </Link>
                </li>
                <li>
                  <a 
                    href="#" 
                    className="text-gray-300 hover:text-[#E71B25] transition-colors text-base py-2 cursor-pointer block group"
                  >
                    <i className="ri-arrow-right-s-line mr-2 group-hover:translate-x-1 transition-transform"></i>
                    Defense
                  </a>
                </li>
                <li>
                  <a 
                    href="#" 
                    className="text-gray-300 hover:text-[#E71B25] transition-colors text-base py-2 cursor-pointer block group"
                  >
                    <i className="ri-arrow-right-s-line mr-2 group-hover:translate-x-1 transition-transform"></i>
                    Consulting
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="mt-16 pt-8 border-t border-gray-600">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
              <p className="text-gray-400 text-sm">© 2025 Vipa Trading Company — All rights reserved.</p>
              <div className="flex flex-col md:flex-row md:items-center gap-4">
                <div className="flex items-center gap-4">
                  <a 
                    href="#" 
                    className="w-10 h-10 bg-gray-700 hover:bg-[#E71B25] rounded-lg flex items-center justify-center transition-colors text-lg cursor-pointer group" 
                    aria-label="LinkedIn"
                  >
                    <i className="ri-linkedin-fill group-hover:scale-110 transition-transform"></i>
                  </a>
                  <a 
                    href="#" 
                    className="w-10 h-10 bg-gray-700 hover:bg-[#E71B25] rounded-lg flex items-center justify-center transition-colors text-lg cursor-pointer group" 
                    aria-label="Instagram"
                  >
                    <i className="ri-instagram-fill group-hover:scale-110 transition-transform"></i>
                  </a>
                  <a 
                    href="#" 
                    className="w-10 h-10 bg-gray-700 hover:bg-[#E71B25] rounded-lg flex items-center justify-center transition-colors text-lg cursor-pointer group" 
                    aria-label="Twitter"
                  >
                    <i className="ri-twitter-fill group-hover:scale-110 transition-transform"></i>
                  </a>
                </div>
                <div className="flex items-center gap-3 md:border-l md:border-gray-600 md:pl-4">
                  <div className="flex items-center gap-2 text-xs text-gray-400">
                    <i className="ri-medal-line text-[#E71B25]"></i>
                    <span>ISO 9001</span>
                  </div>
                  <div className="flex items-center gap-2 text-xs text-gray-400">
                    <i className="ri-shield-check-line text-[#E71B25]"></i>
                    <span>HSE Certified</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* Quote Modal */}
      {isQuoteModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl max-w-md w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex items-center justify-between mb-6">
                <h3 className="text-2xl font-bold text-gray-900">Request Quote</h3>
                <button
                  onClick={() => setIsQuoteModalOpen(false)}
                  className="text-gray-500 hover:text-gray-700 cursor-pointer"
                >
                  <i className="ri-close-line text-2xl"></i>
                </button>
              </div>
              <form id="quote-form" onSubmit={handleQuoteSubmit} data-readdy-form>
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Full Name</label>
                    <input
                      type="text"
                      name="name"
                      value={quoteFormData.name}
                      onChange={(e) => setQuoteFormData({...quoteFormData, name: e.target.value})}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent text-sm"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Email Address</label>
                    <input
                      type="email"
                      name="email"
                      value={quoteFormData.email}
                      onChange={(e) => setQuoteFormData({...quoteFormData, email: e.target.value})}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent text-sm"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Phone Number</label>
                    <input
                      type="tel"
                      name="phone"
                      value={quoteFormData.phone}
                      onChange={(e) => setQuoteFormData({...quoteFormData, phone: e.target.value})}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent text-sm"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Company Name</label>
                    <input
                      type="text"
                      name="company"
                      value={quoteFormData.company}
                      onChange={(e) => setQuoteFormData({...quoteFormData, company: e.target.value})}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent text-sm"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Service Type Required</label>
                    <input
                      type="text"
                      name="service"
                      value={quoteFormData.service}
                      onChange={(e) => setQuoteFormData({...quoteFormData, service: e.target.value})}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent text-sm"
                      placeholder="e.g., Gold Bullion Trading"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Additional Details</label>
                    <textarea
                      name="message"
                      value={quoteFormData.message}
                      onChange={(e) => {
                        if (e.target.value.length <= 500) {
                          setQuoteFormData({...quoteFormData, message: e.target.value});
                        }
                      }}
                      rows={4}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent text-sm resize-none"
                      placeholder="Tell us about your requirements..."
                      maxLength={500}
                    ></textarea>
                    <div className="text-xs text-gray-500 mt-1">{quoteFormData.message.length}/500 characters</div>
                  </div>
                </div>
                <div className="mt-6">
                  <button
                    type="submit"
                    disabled={isQuoteSubmitting}
                    className="w-full bg-red-600 text-white py-3 rounded-lg font-semibold hover:bg-red-700 transition-colors disabled:opacity-50 cursor-pointer"
                  >
                    {isQuoteSubmitting ? 'Sending...' : 'Submit Request'}
                  </button>
                </div>
                {quoteSubmitStatus && (
                  <div className={`mt-4 p-3 rounded-lg text-sm ${quoteSubmitStatus.includes('successfully') ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                    {quoteSubmitStatus}
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Contact Modal */}
      {isContactModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl max-w-md w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex items-center justify-between mb-6">
                <h3 className="text-2xl font-bold text-gray-900">Send Message</h3>
                <button
                  onClick={() => setIsContactModalOpen(false)}
                  className="text-gray-500 hover:text-gray-700 cursor-pointer"
                >
                  <i className="ri-close-line text-2xl"></i>
                </button>
              </div>
              <form id="contact-form" onSubmit={handleContactSubmit} data-readdy-form>
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Full Name</label>
                    <input
                      type="text"
                      name="name"
                      value={contactFormData.name}
                      onChange={(e) => setContactFormData({...contactFormData, name: e.target.value})}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent text-sm"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Email Address</label>
                    <input
                      type="email"
                      name="email"
                      value={contactFormData.email}
                      onChange={(e) => setContactFormData({...contactFormData, email: e.target.value})}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent text-sm"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Phone Number</label>
                    <input
                      type="tel"
                      name="phone"
                      value={contactFormData.phone}
                      onChange={(e) => setContactFormData({...contactFormData, phone: e.target.value})}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent text-sm"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Message</label>
                    <textarea
                      name="message"
                      value={contactFormData.message}
                      onChange={(e) => {
                        if (e.target.value.length <= 500) {
                          setContactFormData({...contactFormData, message: e.target.value});
                        }
                      }}
                      rows={5}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent text-sm resize-none"
                      placeholder="Write your message here..."
                      required
                      maxLength={500}
                    ></textarea>
                    <div className="text-xs text-gray-500 mt-1">{contactFormData.message.length}/500 characters</div>
                  </div>
                </div>
                <div className="mt-6">
                  <button
                    type="submit"
                    disabled={isContactSubmitting}
                    className="w-full bg-red-600 text-white py-3 rounded-lg font-semibold hover:bg-red-700 transition-colors disabled:opacity-50 cursor-pointer"
                  >
                    {isContactSubmitting ? 'Sending...' : 'Send Message'}
                  </button>
                </div>
                {contactSubmitStatus && (
                  <div className={`mt-4 p-3 rounded-lg text-sm ${contactSubmitStatus.includes('successfully') ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                    {contactSubmitStatus}
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GoldServices;